<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="border" style="background-color: white;padding: 1.5rem;border-radius: 5px;">
      <div class="row">
        <div class="col-lg-12 rounded p-2" style="background-color: white;">
          <div class="row">
            <div class="col-md-5 gap-1">
              <h3 class="text-center">Create Album</h3>
              <div class="form-group">
                <label for="albumName">Album Name</label>
                <input id="albumName" v-model="album_name" class="form-control" placeholder="Enter Album Name"
                       type="text">
              </div>
              <div class="form-group">
                <label for="albumDescription">Album Description</label>
                <textarea id="albumDescription" v-model="album_description" class="form-control"
                          placeholder="Album Description"
                          rows="3"></textarea>
              </div>
              <div class="form-group">
                <label for="slug">Slug</label>
                <input id="slug" v-model="album_slug" class="form-control" placeholder="Enter Slug" type="text">
              </div>
              <div class="form-group mb-3">
                <label for="albumStatus">Album Status</label>
                <select id="albumStatus" v-model="active_yn" class="form-control">
                  <option disabled selected>Choose...</option>
                  <option value="Y">Active</option>
                  <option value="N">Inactive</option>
                </select>
              </div>
              <div class="form-group">
                <label for="featuredYN">Home Featured?</label>
                <select id="featuredYN" v-model="featured_yn" class="form-control">
                  <option disabled selected>Choose...</option>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>
              <button class="btn btn-primary" type="button" @click="showAddImages = true">
                Add Images
              </button>
              <button class="btn btn-success float-end" type="button" @click="saveAlbum">Save Album</button>
            </div>
            <!-- right side bar -->
            <div class="col-md-7">
              <h3 class="text-center mb-4">Album Images</h3>
              <div v-if="selectedMediaFilePaths.length > 0" class="row mx-3 border rounded p-3">
                <template v-for="(info, index) in selectedMediaFilePaths" :key="index">
                  <div class="col-3">
                    <button aria-label="Close" class="btn-danger mb-2 px-1" style="padding: 0%;"
                            type="button"
                            @click="selectedMediaForAlbum.splice(index, 1),selectedMediaFilePaths.splice(index, 1)">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                    <img :src="info" alt="media"
                         class="img-thumbnail mb-3"
                         style="display:flex;justify-content: center;align-items: center;width:120px; height: 120px; background-color: rgb(244, 245, 245);border-radius: 6px;">
                  </div>
                </template>
              </div>
              <!-- albums  -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  modal-->
    <div v-if="showAddImages">
      <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
           class="modal fade show" role="dialog" style="display: block;"
           tabindex="-1">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Images to Album</h5>
              <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                      type="button" @click="showAddImages = false"></button>
            </div>
            <div class="modal-body" style="height: 70vh; overflow-y: auto;">
              <selectable-media-component :fetchImageIds="selectedMediaForAlbum"
                                          @imgList="getImages"/>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                      @click="showAddImages = false">Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import MediaService from "@/services/media.service";
import Config from '@/config/index.js';
import selectableMedia from "@/components/Media/SelectableMedia.vue";
// import selectable

export default {
  name: "CreateAlbum",
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Media',
          to: '/album/show'
        }, {
          text: 'Add Album',
          href: '#'
        }
      ],
      showAddImages: false,
      album_id: null,
      album_name: null,
      album_slug: null,
      active_yn: 'Y',
      featured_yn: 'N',
      album_description: null,
      all_images: [],
      selectedMediaForAlbum: [],
      selectedMediaFilePaths: [],
      album: {
        id: null,
        album_name: null,
        slug: null,
        active_yn: 'Y',
        featured_yn: 'N',
        album_description: null,
        mediaIds: [],
      },
    }
  },
  components: {
    "selectable-media-component": selectableMedia,
  },
  computed: {},
  watch: {
    album_name(newAlbumName) {
      this.album_slug = newAlbumName.toLowerCase().replace(/ /g, "-");
    },
  },
  methods: {
    getImages(data) {
      this.selectedMediaForAlbum = [];
      this.selectedMediaFilePaths = [];
      const parsedData = JSON.parse(data);
      parsedData.forEach((element) => {
        this.selectedMediaForAlbum.push(
            element[0].media_file_id,
        );
        this.selectedMediaFilePaths.push(
            Config.apiFileBasePath + "/thumbnail" + element[0].thumbnail_file_path,
        );
      });
    },
    async saveAlbum() {
      this.setAlbumData();
      try {
        const response = await MediaService.createAlbum(this.album);
        if (response.data) {
          if (response.data.messageCode === 1) {
            this.showNotification('success', response.data.message);
          } else {
            this.showNotification('error', response.data.message);
          }
        } else {
          this.showNotification('error', response.data.message);
        }

      } catch (error) {
        console.error(error);
      }
    },
    setAlbumData() {
      this.album.album_name = this.album_name;
      this.album.slug = this.album_slug;
      this.album.active_yn = this.active_yn;
      this.album.featured_yn = this.featured_yn;
      this.album.album_description = this.album_description;
      this.album.mediaIds = this.selectedMediaForAlbum;
    },
    showNotification(type, message) {
      this.$notify({
        type: type,
        title: 'Upload Media',
        text: message
      });
    }

  },
}
</script>
<style></style>

